import { FC } from 'react'
import { Box } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { colors } from '../../const/colors'

const DayCheckbox: FC<{ checked: boolean }> = ({ checked }) => (
  <Box
    sx={{
      flexShrink: 0,
      width: 19,
      height: 19,
      borderRadius: '6px',
      border: `1.5px solid ${checked ? colors.navy : colors.border3}`,
      background: checked ? colors.navy : colors.surface,
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background .12s, border-color .12s',
    }}
  >
    {checked && <CheckIcon sx={{ fontSize: 13 }} />}
  </Box>
)

export default DayCheckbox
